import { Component, OnInit, ElementRef } from '@angular/core';
import { OrderEntryModal } from '../orderentry/orderentry.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data/data.service';
import { CookiesService } from '../../../tools/cookies.service';
import { WorkspaceServiceService } from '../../../services/workspace-service.service';

@Component({
  selector: 'mobile-order-entry-modal',
  template: require('./mobile-order-entry-modal.component.html'),
  styles: [require('./mobile-order-entry-modal.component.css')]
})
export class MobileOrderEntryModalComponent extends OrderEntryModal {

  
  get horizontal()
  {
    return this.workspaceService.data.horizontalMode;
  }
  
  constructor(
    public activeModal: NgbActiveModal,
    protected element: ElementRef,
    protected dataService: DataService,
    protected modalService: NgbModal,
    protected cookieService: CookiesService,
    protected workspaceService: WorkspaceServiceService,
    protected workspaceServiceService: WorkspaceServiceService
  ) {
    super(activeModal, element, dataService, modalService, cookieService, workspaceService, workspaceServiceService)  
  }
}
